import React from 'react'
import {TextArea, InputView, Loading} from './InputStyles'

const TextAreaInput = ({type, t, loading, ...props}) => (
  <InputView>
    <TextArea {...props} />
    {loading && <Loading {...props} />}
  </InputView>
)

export default TextAreaInput
